import type { BrowserTestContext } from "@/dev/BrowserTestContext.ts";
import * as dom from "@testing-library/dom";
import userEvent from "@testing-library/user-event";

export function testingLibraryContext(canvasElement: HTMLElement = document.body): BrowserTestContext {
    return {
        canvasElement,
        canvas: dom.within(canvasElement),
        userEvent,
        dom,
        step(label, callback) {
            console.debug("[Step: %s]", label);
            return callback();
        },
    };
}
